export default __webpack_public_path__ + "static/media/Вход в систему.08ecdde4.md";